import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import AvailabilitiesTable from './AvailabilitiesTable';
import AvailabilitySelect from './AvailabilitySelect/AvailabilitySelect';

interface IAvailabilitiesProps extends RouteComponentProps<{
  eshop: string;
  availabilityId: string;
}> {

}

export default class Availabilities extends React.Component<IAvailabilitiesProps> {

  render() {
    return (
      <div>
        <AvailabilitiesTable
          domain={this.props.match.params.eshop}
          availabilityId={this.props.match.params.availabilityId}
        />
      </div>
    );
  }
}

export {
  AvailabilitySelect,
};


// WEBPACK FOOTER //
// ./src/scenes/Availabilities/index.tsx